import { OfferType } from '@occc-app/routes/Offer/types';

export const requiresActivationApplicableOfferTypes: OfferType[] = [
  OfferType.ProductPurchase,
  OfferType.SpendBonus,
  OfferType.BaseEligibleEarn,
];
